import { motion, useInView } from "framer-motion";
import { useEffect, useMemo, useRef, useState } from "react";
import Cross from "../../../public/images/Cross";
import CardsApps from "../../components/CardsApps/CardsApps";
import FormWrapper from "../../helpers/FormVoip/FormWrapper";
import "./apps.scss";

export default function Apps() {
  const [openForm, setOpenForm] = useState(false);
  const [openOptions, setOpenOptions] = useState(false);
  useEffect(() => {
    if (openOptions) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [openOptions]);
  const ref = useRef(null);
  const inView = useInView(ref, { amount: 0.35, once: true });

  const variants = useMemo(
    () => ({
      left: {
        hidden: { opacity: 0, x: -220, y: 0 },
        visible: { opacity: 1, x: 0, y: 0, transition: { duration: 0.7 } },
        out: { opacity: 0, x: -320, y: 0, transition: { duration: 0.6 } },
      },
      mid: {
        hidden: { opacity: 0, x: -160, y: 0 },
        visible: { opacity: 1, x: 0, y: 0, transition: { duration: 0.8 } },
        out: { opacity: 0, x: -360, y: 0, transition: { duration: 0.7 } },
      },
      right: {
        hidden: { opacity: 0, x: 220, y: 0 },
        visible: { opacity: 1, x: 0, y: 0, transition: { duration: 0.7 } },
        out: { opacity: 0, x: 320, y: 0, transition: { duration: 0.6 } },
      },
    }),
    [],
  );

  const state = inView ? "visible" : "out";

  return (
    <div className="apps">
      <div className="apps__title">
        <h2>
          We build <span>scalable</span> & <span>smart solutions</span>
        </h2>
        <p>
          At [Your Company Name], we're passionate about crafting{" "}
          <span>exceptional software solutions</span> that drive value for your
          business. With a focus on <span>innovation and excellence</span>, we
          create <span>bespoke digital experiences</span>
          tailored to your unique needs and objectives.
        </p>
      </div>
      <div className="apps__offers">
        <div className="apps__offers__offer">
          <img src="/images/development.svg" alt="" />
          <h3>Development</h3>
          <p>
            Our team of seasoned developers combines technical expertise with
            creative flair to deliver bespoke solutions that cater to your
            unique requirements.
          </p>
        </div>
        <div className="apps__offers__offer">
          <img src="/images/service.svg" alt="" />
          <h3>Service</h3>
          <p>
            With a relentless pursuit of excellence and a commitment to customer
            satisfaction, we strive to build lasting partnerships that drive
            success and propel businesses forward.
          </p>
        </div>
        <div className="apps__offers__offer">
          <img src="/images/team.svg" alt="" />
          <h3>Team</h3>
          <p>
            With a dedication to staying ahead of industry trends and adopting
            cutting-edge technologies, we ensure that we deliver the highest
            quality solutions to our clients.
          </p>
        </div>
      </div>
      <div className="apps__about">
        <div className="apps__about__info">
          <h2>Who we are</h2>
          <p>
            We are a web & app development company that turns your ideas into a
            new driving force of your business.
          </p>
          <button onClick={() => setOpenOptions(!openOptions)}>By now</button>
          {openOptions && (
            <div
              className="apps__about__info__optionsOverlay"
              onClick={() => setOpenOptions(false)}
            >
              <div
                className="apps__about__info__optionsOverlay__listOptions"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="apps__about__info__optionsOverlay__listOptions__title">
                  <h3>Please, select your option</h3>
                  <button onClick={() => setOpenOptions(false)}>
                    <Cross color="#c3c3c4" />
                  </button>
                </div>
                <div className="apps__about__info__optionsOverlay__listOptions__variants">
                  <div className="apps__about__info__optionsOverlay__listOptions__variants__variant">
                    <h4>Telegram</h4>
                    <img src="/images/telegramVariant.svg" alt="" />
                  </div>
                  <div className="apps__about__info__optionsOverlay__listOptions__variants__variant">
                    <h4>Web site</h4>
                    <img src="/images/webSiteVariant.svg" alt="" />
                  </div>
                  <div className="apps__about__info__optionsOverlay__listOptions__variants__variant">
                    <h4>Operator</h4>
                    <img src="/images/operatorVariant.svg" alt="" />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div ref={ref} className="apps__about__services">
          <motion.div
            className="apps__about__services__service"
            variants={variants.left}
            initial="hidden"
            animate={state}
          >
            <h3>Custom Solutions</h3>
            <p>
              Our expertise helps us develop web and mobile solutions tailored
              with care for our clients.
            </p>
          </motion.div>

          <motion.div
            className="apps__about__services__service"
            variants={variants.mid}
            initial="hidden"
            animate={state}
          >
            <h3>Mobile Applications</h3>
            <p>
              We also deliver products with outsourcing app development model.
            </p>
          </motion.div>

          <motion.div
            className="apps__about__services__service"
            variants={variants.right}
            initial="hidden"
            animate={state}
          >
            <h3>Team Work</h3>
            <p>
              Our team connects conventional essential technologies and
              architecture with the unique logic of the app.
            </p>
          </motion.div>
        </div>
      </div>
      <CardsApps />
      <div className="apps__buy">
        <h2>By now</h2>
        <p>
          Contact center is one of the key tools that you need to run operations
          easily.
        </p>
        <button onClick={() => setOpenForm(true)}>By now</button>
      </div>
      {openForm && <FormWrapper onClose={() => setOpenForm(false)} />}
    </div>
  );
}
